<template>
  <div
    :class="{ 'opacity-0 transition-opacity duration-300 ease-out': done }"
    class="fixed inset-0 z-50 flex h-full w-full items-center justify-center bg-black/50"
  >
    <div
      class="flex w-[75vw] select-none flex-col items-center space-y-2 font-medium lg:w-96"
    >
      <div class="progress w-full rounded-lg bg-gray-100 p-[1px]">
        <div
          class="h-1.5 w-[97%] animate-loadingbar rounded-xl bg-black transition-all duration-500 ease-linear"
        ></div>
      </div>
      <span v-if="currentStep" class="w-full text-center text-white">
        {{ currentStep }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PropType, watch } from 'vue';

const emit = defineEmits(['destroy-me']);

const props = defineProps({
  successfulSteps: {
    type: Array as PropType<string[]>,
    required: false,
    default: () => [],
  },

  currentStep: {
    type: String,
    required: false,
    default: undefined,
  },

  done: {
    type: Boolean,
    required: false,
    default: false,
  },
});

watch(
  () => props.done,
  (done: boolean) => {
    if (done) {
      // When done is set to true, an event is emitted to let the parent know to destroy the element
      setTimeout(() => {
        emit('destroy-me');
      }, 305);
    }
  }
);
</script>
